import { Text } from '@/app/components/text';

import DistributorItem from './distributor-item';

import type { DistributorListingProps } from './distributor.types';

const DistributorListing = ({
  title,
  distributors,
}: DistributorListingProps) => (
  <>
    <div className="py-b">
      <Text
        as="h3"
        variant="h3"
      >
        {title}
      </Text>
    </div>

    {distributors.length > 0 ? (
      <div role="list">
        {distributors.map((distributor) => (
          <DistributorItem
            key={distributor.id}
            {...distributor}
          />
        ))}
      </div>
    ) : null}
  </>
);

export default DistributorListing;
